export interface EnumEntity {
  name: string;
  items: EnumItem[];
  value_type: "string" | "number";
}

export interface FormEntity {
  name: string;
  label: string;
  api: number;
  buttons: Button[];
  controls: FormControl[];
}

export enum Size {
  Small,
  Medium,
  Big,
  Huge,
}

export enum LoginType {
  BSC,
  Terra,
  Email,
  Avalanche,
  Facebook,
  Google,
  GoogleMobile,
  SavedToken,
  Okex,
  Apple,
  Guest,
  Aura,
  Twitter,
  Farmer,
}

export enum CustomerRole {
  Owner,
  Farmer
}

export enum CellDisplay {
  Text = "text",
  Number = "number",
  Date = "date",
  Image = "image",
  Switch = "switch",
  Enum = "enum",
  Entity = "entity",
  JSON = "json",
  Entities = "entities",
  ArrayString = "arraystring",
  File = "file",
}

export interface SearchItem {
  label: string;
  field: string;
  type: "text" | "number" | "date";
  control?: "input" | "enum";
  isRange: boolean;
  enum?: string;
  multiple?: boolean;
}

export interface GridColumn {
  label: string;
  field: string;
  sortField?: string;
  display: CellDisplay;
  api?: string;
  sorter?: boolean;
  defaultSortOrder?: string;
  enumName?: string;
  fixed?: string;
  width: number;
}

export interface Button {
  label: string;
  pageMode?: string;
  classes?: string;
  icon?: string;
  showInColumn?: string;
  action: "api" | "redirect";
  api?: string;
  redirectUrl?: string;
  redirectUrlEmbed?: any;
  embedData?: object;
  popupData?: object;
  confirmText?: string;
  backOnAction?: boolean;
  position?: string;
  successMessage?: string;
  failMessage?: string;
  disableReload?: boolean;
  hideExpression?: object;
}

export enum SchemaDataType {
  String = "string",
  Number = "number",
  Boolean = "boolean",
  Array = "array",
  Object = "object",
}

export enum SchemaControl {
  Enum = "enum",
  Text = "text",
  TextArea = "textarea",
  Image = "image",
  ArrayImage = "arrayimage",
  Location = "location",
  RichText = "richtext",
  Password = "password",
  Captcha = "captcha",
  Label = "label",
  Step = "step",
  Entity = "entity",
  JSON = "json",
  Date = "date",
  TextArray = "textarray",
  Divider = "divider",
  CheckList = "checklist",
  Schema = "schema",
  Teacher = "teacher",
  Upload = "upload",
}

export interface FormControl {
  label: string;
  field: string;
  dataType: SchemaDataType;
  caption?: string;
  required: boolean;
  disabled: boolean;
  control: SchemaControl;
  gridName: string;
  schemaName: string;
  enum: string;
  hideExpression?: object;
  requireExpression?: object;
  api: string;
  multiple?: boolean;
}

export enum Language {
  English,
  Chinese,
}

export interface EnumItem {
  value: string;
  label: string;
  classes?: string;
}

export interface GridEntity {
  name: string;
  label: string;
  api: string;
  buttons: Button[];
  columns: GridColumn[];
  filter: SearchItem[];
}

export enum UserRole {
  Owner,
  Farmer
}

export interface UserEntity {
  "A": number, // "id",
  "B": boolean, // "in_battle",
  "C": string, // "user_name",
  "D": string, // "name",
  "E": number, // "avatar",
  "F": number, // "progress",
  "G": number, // "food",
  "H": number, // "mag",
  "I": number, // "mstr",
  "J": number, // "evolution_items",
  "K": number, // "energy",
  "L": number, // "nm_st",
  "M": number, // "rr_st",
  "N": number, // "el_st",
  "O": number, // "nmr_st",
  "P": number, // "rrr_st",
  "Q": number, // "elr_st",
  "R": number, // "active_land_id",
  "S": number, // "exp",
  "T": boolean, // "is_block",
  "U": number, // "level",
  "V": number, // "level_reward",
  "X": number, // referral_customer_id
  "Y": Date, // referral_last_submit
  "Z": number, // ticket_co
  "AA": number, // ticket_uc
  "AB": number, // ticket_ra
  "AC": number, // ticket_ep
  "AD": number, // ticket_le
  "AE": Date, // created_at
  "AF": number, // referred_claimed_rewards
  "AG": number, // adventure_star_reward
  "AH": number, // adventure_star
  "AI": number, // count_refill_energy
  "AJ": number, // staked_mag
  "AK": number, // earn_mag
  "AR": number, // ticket_ge
  "AS": number, // ticket_gl
  "BZ": number,
  "CA": number,
  "CE": number[], // dao_stake_point [rarity]
  "CO": any,
  "CP": number,
  mstr_wallet?: number,
  mag_wallet?: number,
  usdt_wallet?: number,
  TICKETCO_wallet?: number,
  TICKETUC_wallet?: number,
  TICKETRA_wallet?: number,
  TICKETEP_wallet?: number,
  TICKETGE_wallet?: number,
  TICKETGL_wallet?: number,
  elixir_wallet?: number,
  mutategen_wallet?: number,
}

export interface AuthEntity {
  "A": number, // "id",
  "B": number, // "customer_id",
  "C": string, // "identity",
  "D": number, // "type",
  "E": number, // "role",
  "F": string, // "password",
  "G": boolean, // "is2FARequired",
  "H": string, // password_last_update
  "I": boolean, // is_2fa_enabled
  mstr_wallet: number,
  mag_wallet: number,
}

export interface CustomerTransaction {
  "A": number, // id,
  "B": number, // customer_i,d,
  "C": Token, // token_type,
  "D": number, // value
  "E": Date, // claim_at
  "F": boolean, // is_claim
  "G": string, //wallet address
  "H": Date, // create_at
}

export enum ButtonColor {
  'red',
  'orange',
  'blue',
  'yellow',
  'gray',
  'purple',
  'brown'
}

export enum ButtonVariant {
  'primary',
  'outline',
}

export enum GameItem {
  'mag',
  'mstr',
  'evo-item',
}

export enum RewardType {
  FOOD,
  EVOLUTION_ITEM,
  LOCK_MAG,
  EXP,
  SOULCORE,
  MSTR,
  PLOT,
  BOX,
  TICKET,
  NormalStone,
  RerollStone,
  EliteStone,
  NormalRuneStone,
  RerollRuneStone,
  EliteRuneStone,
  TROPHY_SCORE,
  BattleFrontShield,
  Energy,
  Avatar,
  DecorationList,
  Pigment,
  DailyQuestPoint,
  UNLOCK_MAG,
  BLESSING,
  EMOJI,
  BATTLEPASS_EXP,
  ElectiveStoneCO,
  ElectiveRuneStoneCO,
  ElectiveStoneUC,
  ElectiveRuneStoneUC,
  ElectiveStoneRA,
  ElectiveRuneStoneRA,
  ElectiveStoneEP,
  ElectiveRuneStoneEP,
  ElectiveStoneLE,
  ElectiveRuneStoneLE,
  BattleQuestMongenAlive,
  BattleQuestMongenDefeat,
  Rune,
  Mongen,
  BATTLEPASS_EXP_ARENA,
  AbyssStar,
  AbyssHealMongen,
  AbyssReviveMongen,
  AbyssUndyingTroop,
  GPoint,
  ClanEXP,
  AWish,
  AbyssHealMongen25,
  AbyssHealMongen75,
  AbyssHealMongen100,
  Jackpot,
}
export interface RewardEntity {
  reward_type: RewardType;
  reward_quantity: number;
  plot_type?: PlotType;
  race?: MongenRace;
  rarity?: Rarity | TicketRarity;
  rate?: number;
  reward_pool_id?: number;
  min?: number;
  max?: number;
  total_rewards?: number;
  avatar_id?: number;
  decoration_code?: string;
  is_high_fee?: boolean;
  sub_plot_type?:
  | TrapType
  | BombardType
  | CampType
  | TowerType
  | BarrackType
  | -1;
  emoji_id?: string;
  is_premium?: boolean;
  box_name?: string;
  rune_code?: string;
}

export enum PlotType {
  LandCore,
  Pasture,
  Breeding,
  Hatching,
  Production,
  Storage,
  Camp,
  Tower,
  Bombard,
  Trap,
  Barracks,
  Decor,
  All,
}

export enum Token {
  MAG,
  MSTR,
  USDT
}

export enum Rarity {
  Common,
  Uncommon,
  Rare,
  Epic,
  Legendary,
  All,
}

export enum TicketRarity {
  Common,
  Uncommon,
  Rare,
  Epic,
  Legendary,
  GE,
  GL
}

export enum MongenRace {
  Beast,
  Tectos,
  Mystic,
  Celest,
  Chaos,
  All,
}

export interface GasPrice {
  denom: string,
  price: number,
}

export enum NFTType {
  Mongen,
  SoulCore,
  Land,
  Plot,
  EvolutionItem,
  NormalStone,
  RerollStone,
  EliteStone,
  NormalRuneStone,
  RerollRuneStone,
  EliteRuneStone,
  TicketCO,
  TicketUC,
  TicketRA,
  TicketEP,
  TicketLE,
  TicketGE,
  TicketGL,
  Pigment,
  Box,
  ElectiveStoneCO,
  ElectiveRuneStoneCO,
  ElectiveStoneUC,
  ElectiveRuneStoneUC,
  ElectiveStoneRA,
  ElectiveRuneStoneRA,
  ElectiveStoneEP,
  ElectiveRuneStoneEP,
  ElectiveStoneLE,
  ElectiveRuneStoneLE,
  Elixir,
  MutatedGen,
  Rune,
}

export enum Chain {
  BSC,
  Terra,
  Avalanche,
  Okex,
  Aura
}

export const CustomerFields = [
  "id",
  "in_battle",
  "user_name",
  "name",
  "avatar",
  "progress",
  "food",
  "mag",
  "mstr",
  "evolution_items",
  "energy",
  "nm_st",
  "rr_st",
  "el_st",
  "nmr_st",
  "rrr_st",
  "elr_st",
  "active_land_id",
  "exp",
  "is_block",
  "level",
  "level_reward",
  "fame",
  "referral",
  "referral_last_submit",
  "ticket_co",
  "ticket_uc",
  "ticket_ra",
  "ticket_ep",
  "ticket_le",
  "created_at",
  "referred_claimed_rewards",
  "adventure_star_reward",
  "adventure_star",
  "count_refill_energy",
  "staked_mag",
  "earn_mag",
  "collected_plots",
  "souldcore_hatched",
  "breeding_count",
];

export const AuthFields = [
  "id",
  "customer_id",
  "identity",
  "type",
  "role",
  "password",
  "is2FARequired",
  "password_last_update",
  "is_2fa_enabled",
];

export enum CustomerTransactionStatus {
  Pending,
  Canceled,
  Claimed,
  Processing
}

export enum CaptchaStatus {
  NEEDED,
  SHOWING,
  VERIFIED,
}

export enum CustomerInterface {
  id = "A",
  in_battle = "B",
  user_name = "C",
  name = "D",
  avatar = "E",
  progress = "F",
  food = "G",
  mag = "H",
  mstr = "I",
  evolution_items = "J",
  energy = "K",
  nm_st = "L",
  rr_st = "M",
  el_st = "N",
  nmr_st = "O",
  rrr_st = "P",
  elr_st = "Q",
  active_land_id = "R",
  exp = "S",
  is_block = "T",
  level = "U",
  level_reward = "V",
  fame = "W",
  referral = "X",
  referral_last_submit = "Y",
  ticket_co = "Z",
  ticket_uc = "AA",
  ticket_ra = "AB",
  ticket_ep = "AC",
  ticket_le = "AD",
  created_at = "AE",
  referred_claimed_rewards = "AF",
  adventure_star_reward = "AG",
  adventure_star = "AH",
  count_refill_energy = "AI",
  staked_mag = "AJ",
  earn_mag = "AK",
  collected_plots = "AL",
  souldcore_hatched = "AM",
  breeding_count = "AN",
  scholar_owner = "AO",
  scholar_permissions = "AP",
  scholar_address = "AQ",
  ticket_ge = "AR",
  ticket_gl = "AS",
  level_reward_info = "AT",
  earn_ft = "AU",
  avatar_pool = "AV",
  sharing_rate = "AW",
  expect_earning = "AX",
  scholar_id = "AY",
  max_capacity = "AZ",
  scholar_expired_at = "BA",
  energy_event = "BB",
  count_buy_energy_event = "BC",
  battlefront_mongen_team = "BD",
  boss_mongen_team = "BE",
  bonus_tuts = "BF",
  pigment = "BG",
  action_points = "BH",
  curse_effect_receive = "BI",
  bless_receive_list = "BJ",
  emoji_pool = "BK",
  elective_st_co = "BL",
  elective_rune_st_co = "BM",
  elective_st_uc = "BN",
  elective_rune_st_uc = "BO",
  elective_st_ra = "BP",
  elective_rune_st_ra = "BQ",
  elective_st_ep = "BR",
  elective_rune_st_ep = "BS",
  elective_st_le = "BT",
  elective_rune_st_le = "BU",
  spent_mstr = "BV",
  expired_newbie_blessing = "BW",
  nft_points = "BX",
  max_token_capacity = "BY",
  elixir = "BZ",
  mutated_gen = "CA",
  dao_stake_point = "CE", // dao_stake_point [rarity]
  iap_lock_util = "CO",
  usdt_guaranteed = "CP",
}

export enum TransactionInterface {
  id = "A",
  customer_id = "B",
  token_type = "C",
  value = "D",
  claim_at = "E",
  is_claim = "F",
  wallet_address = "G",
  created_at = "H",
  fee = "I",
  tx_hash = "J",
  chain = "K",
  status = "L",
  lock_processing = "M"
};

export enum AuthInterface {
  id = "A",
  customer_id = "B",
  identity = "C",
  type = "D",
  role = "E",
  password = "F",
  is2FARequired = "G",
  password_last_update = "H",
  is_2fa_enabled = "I",
}

export enum ContractType {
  MSTR = "MSTR",
  Admin = "ADMIN",
  Skill = "SKILL",
  MAG = "MAG",
  Mongen = "MONGEN",
  SoulCore = "SOULCORE",
  Land = "LAND",
  Plot = "PLOT",
  EvolutionItem = "EVOLUTIONITEM",
  NormalStone = "NORMALSTONE",
  RerollStone = "REROLLSTONE",
  EliteStone = "ELITESTONE",
  NormalRuneStone = "NORMALRUNESTONE",
  RerollRuneStone = "REROLLRUNESTONE",
  EliteRuneStone = "ELITERUNESTONE",
  TicketCO = "TICKETCO",
  TicketUC = "TICKETUC",
  TicketRA = "TICKETRA",
  TicketEP = "TICKETEP",
  TicketLE = "TICKETLE",
  TicketGE = "TICKETGE",
  TicketGL = "TICKETGL",
  ticket_co = "TICKETCO",
  ticket_uc = "TICKETUC",
  ticket_ra = "TICKETRA",
  ticket_ep = "TICKETEP",
  ticket_le = "TICKETLE",
  ticket_ge = "TICKETGE",
  ticket_gl = "TICKETGL",
  STAKING = "STAKING",
  ConvertBox = "CONVERTBOX",
  Pigment = "PIGMENT",
  Box = "BOX",
  SkipQuest = "SKIPQUEST",
  ElectiveStoneCO = "ELECTIVESTONECO",
  ElectiveRuneStoneCO = "ELECTIVERUNESTONECO",
  ElectiveStoneUC = "ELECTIVESTONEUC",
  ElectiveRuneStoneUC = "ELECTIVERUNESTONEUC",
  ElectiveStoneRA = "ELECTIVESTONERA",
  ElectiveRuneStoneRA = "ELECTIVERUNESTONERA",
  ElectiveStoneEP = "ELECTIVESTONEEP",
  ElectiveRuneStoneEP = "ELECTIVERUNESTONEEP",
  ElectiveStoneLE = "ELECTIVESTONELE",
  ElectiveRuneStoneLE = "ELECTIVERUNESTONELE",
  BnbGlory = "BNBGLORY",
  Elixir = "ELIXIR",
  Fusion = "FUSION",
  MutatedGen = "MUTATED_GEN",
  USDT = "USDT",
  USDTStaking = "USDTSTAKING",
}

export type SSO_TYPE = {
  DAOLink: string;
  GuideLink: string;
  DaoGuildLink: string;
  LiteLink: string;
  GameLink: string;
  SupportLink: string;
  TerraChainId: string;
  BattleLink: string;
  PortalLink: string;
  BridgeLink: string;
  GuildLink: string;
  EventLink: string;
  MarketLink: string;
  DocsLink: string;
  MonstvLink: string;
  MonsterraverseLink: string;
  LandingPage: string;
  contract: any;
  network: any;
  GOOGLE_CLIENT_ID: string;
  FACEBOOK_APP_ID: string;
  CAPTCHA_CLIENT_ID: string;
  AuraChainInfo: any;
  S3Host: string;
  price: {
    BNB: string;
    AVAX: string;
    LUNA: string;
    UST: string;
    OKT: string;
    AURA: string;
  }
}

export type TicketUnit = "ticket_co" | "ticket_uc" | "ticket_ra" | "ticket_ep" | "ticket_le" | "ticket_ge" | "ticket_gl"

export enum TrapType {
  Default,
  Poison,
  Slowed,
  Paralyzed,
  Confused,
  Bleeding,
  Silence,
  Burned,
  MG,
  STD,
  AGR,
}

export enum BombardType {
  Default,
  RNG,
  ENG,
}

export enum BarrackType {
  Default,
  Food,
}

export enum TowerType {
  Default,
  RNG,
  CD,
}

export enum CampType {
  Default,
  HP,
  MG,
  STD,
  AGR,
}


export enum BodyPart {
  Form,
  Head,
  Eyes,
  Horns,
  Tail,
  Back,
  FrontLeg,
  BackLeg,
  Mouth,
  Aura,
}

export enum MongenState {
  Egg,
  Idle,
  Breeding,
  Working,
  Traning,
  Battle,
}



export enum MongenInterface {
  id = "A",
  name = "B",
  dna = "C",
  customer_id = "D",
  plot_id = "E",
  is_attach = "F",
  level = "G",
  next_level_progress = "H",
  mongen_state = "I",
  evolution = "J",
  is_lock = "K",
  is_free = "L",
  evolution_points = "M",
  land_id = "N",
  births = "O",
  basic_skill = "P",
  ultimate_skill = "Q",
  basic_skill_list = "R",
  ultimate_skill_list = "S",
  is_tut = "T",
  troop_list = "U",
  training_queue = "V",
  freeze_until = "W",
  strategy = "X",
  is_deassigning = "Y",
  mongen_battle = "Z",
  battle_count = "AA",
  acc_battle = "AB",
  win_count = "AC",
  lose_count = "AD",
  fed_food = "AE",
  fed_evolve = "AF",
  fed_stones = "AG",
  loyalty = "AH",
  morale = "AI",
  morale_eff_value = "AJ",
}

export enum PlotInterface {
  id = "A",
  name = "B",
  customer_id = "C",
  plot_type = "D",
  x = "E",
  y = "F",
  size_x = "G",
  size_y = "H",
  plot_race = "I",
  mongen_race = "J",
  rarity = "K",
  level = "L",
  breeding_time = "M",
  hatching_time = "N",
  produce_time = "O",
  upgrade_time = "P",
  production_mode = "Q",
  is_attach = "R",
  attach_mongens = "S",
  is_lock = "T",
  is_free = "U",
  land_id = "V",
  is_land_active = "W",
  training_time = "X",
  freeze_until = "Y",
  decoration_list = "AB",
  sub_plot_type = "AD",
}

export enum AssetType {
  Mongen,
  Plot,
  MAG,
  MSTR,
  Soulcore,
}
export interface NftPoint {
  points: number[];
  fusionElixirCost: number[];
  fusionMstrCost: number[];
  limit_mongen: number[];
  plot_type: number;
  limit_habitat: number[];
  required_mongen: number[];
  max_elixir: number[];
  max_mutatedgen: number[];
  type: number;
}

export enum MstrSharedRevenueTime {
  SixMonth,
  NineMonth,
  TwelveMonth,
  Infinity
}
export enum MstrTimeDisplay {
  SixMonth = '6 months',
  NineMonth = '9 months',
  TwelveMonth = '12 months',
}

export enum KEPLR_ERRORS {
  Success = 'OK',
  Failed = 'FAILED',
  NoChainInfo = 'THERE IS NO CHAIN INFO FOR',
  SameChain = 'SAME CHAIN IS ALREADY REGISTERED',
  NotRegistered = 'CHAIN IS NOT REGISTERED',
  RequestRejected = 'REQUEST REJECTED',
  NotInstall = 'NOT INSTALL',
  NOT_EXIST = "KEY DOESN'T EXIST",
}

export enum WALLET_PROVIDER {
  KEPLR = 'KEPLR',
  COIN98 = 'COIN98',
}

export enum TRANSACTION_TYPE_ENUM {
  IBCTransfer = '/ibc.applications.transfer.v1.MsgTransfer',
  IBCReceived = '/ibc.core.channel.v1.MsgRecvPacket',
  IBCAcknowledgement = '/ibc.core.channel.v1.MsgAcknowledgement',
  IBCUpdateClient = '/ibc.core.client.v1.MsgUpdateClient',
  IBCTimeout = '/ibc.core.channel.v1.MsgTimeout',
  IBCChannelOpenInit = '/ibc.core.channel.v1.MsgChannelOpenInit',
  IBCConnectionOpenInit = '/ibc.core.connection.v1.MsgConnectionOpenInit',
  IBCCreateClient = '/ibc.core.client.v1.MsgCreateClient',
  IBCChannelOpenAck = '/ibc.core.channel.v1.MsgChannelOpenAck',
  Send = '/cosmos.bank.v1beta1.MsgSend',
  MultiSend = '/cosmos.bank.v1beta1.MsgMultiSend',
  Delegate = '/cosmos.staking.v1beta1.MsgDelegate',
  Undelegate = '/cosmos.staking.v1beta1.MsgUndelegate',
  Redelegate = '/cosmos.staking.v1beta1.MsgBeginRedelegate',
  GetReward = '/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward',
  SwapWithinBatch = '/tendermint.liquidity.v1beta1.MsgSwapWithinBatch',
  DepositWithinBatch = '/tendermint.liquidity.v1beta1.MsgDepositWithinBatch',
  EditValidator = '/cosmos.staking.v1beta1.MsgEditValidator',
  CreateValidator = '/cosmos.staking.v1beta1.MsgCreateValidator',
  Unjail = '/cosmos.slashing.v1beta1.MsgUnjail',
  StoreCode = '/cosmwasm.wasm.v1.MsgStoreCode',
  InstantiateContract = '/cosmwasm.wasm.v1.MsgInstantiateContract',
  InstantiateContract2 = '/cosmwasm.wasm.v1.MsgInstantiateContract2',
  ExecuteContract = '/cosmwasm.wasm.v1.MsgExecuteContract',
  ModifyWithdrawAddress = '/cosmos.distribution.v1beta1.MsgSetWithdrawAddress',
  JoinPool = '/osmosis.gamm.v1beta1.MsgJoinPool',
  LockTokens = '/osmosis.lockup.MsgLockTokens',
  JoinSwapExternAmountIn = '/osmosis.gamm.v1beta1.MsgJoinSwapExternAmountIn',
  SwapExactAmountIn = '/osmosis.gamm.v1beta1.MsgSwapExactAmountIn',
  BeginUnlocking = '/osmosis.lockup.MsgBeginUnlocking',
  Vote = '/cosmos.gov.v1beta1.MsgVote',
  Vesting = '/cosmos.vesting.v1beta1.MsgCreateVestingAccount',
  Deposit = '/cosmos.gov.v1beta1.MsgDeposit',
  SubmitProposalTx = '/cosmos.gov.v1beta1.MsgSubmitProposal',
  GetRewardCommission = '/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission',
  PeriodicVestingAccount = '/cosmos.vesting.v1beta1.MsgCreatePeriodicVestingAccount',
  BasicAllowance = '/cosmos.feegrant.v1beta1.BasicAllowance',
  PeriodicAllowance = '/cosmos.feegrant.v1beta1.PeriodicAllowance',
  MsgGrantAllowance = '/cosmos.feegrant.v1beta1.MsgGrantAllowance',
  MsgRevokeAllowance = '/cosmos.feegrant.v1beta1.MsgRevokeAllowance',
  AllowedMsgAllowance = '/cosmos.feegrant.v1beta1.AllowedMsgAllowance',
  AllowedContractAllowance = '/cosmos.feegrant.v1beta1.AllowedContractAllowance',
  GrantAuthz = '/cosmos.authz.v1beta1.MsgGrant',
  ExecuteAuthz = '/cosmos.authz.v1beta1.MsgExec',
  RevokeAuthz = '/cosmos.authz.v1beta1.MsgRevoke',
  MsgMigrateContract = '/cosmwasm.wasm.v1.MsgMigrateContract',
  AuraExecuteContract = '/auranw.aura.wasm.MsgExecuteContract',
  Fail = 'FAILED',
}